// src/App.jsx
import { useTheme } from './hooks/useTheme';
import { useFadeIn } from './hooks/useFadeIn';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
// import Solutions from './components/Solutions';
// import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PageIndicator from './components/PageIndicator';
import './styles/globals.css';

export default function App() {
  const { isDark, toggleTheme } = useTheme();
  useFadeIn();

  return (
    <>
      <Navbar isDark={isDark} toggleTheme={toggleTheme} />
      <PageIndicator />
      <main>
        <Hero />
        <About />
        <Services />
        {/* <Solutions />
        <WhyUs /> */}
        <Contact />
      </main>
      <Footer />
    </>
  );
}
